import React, { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { motion, AnimatePresence } from 'motion/react';
import { RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      // eslint-disable-next-line prefer-template
      console.log('SW Registered: ' + r);
    },
    onRegisterError(error) {
      console.log('SW registration error', error);
    },
  });

  const close = () => {
    setNeedRefresh(false);
  };

  return (
    <AnimatePresence>
      {needRefresh && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="fixed bottom-4 right-4 z-[9999] bg-white border border-gray-200 shadow-xl rounded-lg p-4 w-80 text-sm"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="text-gray-900 font-medium">
              New update available!
            </div>
            <button
              onClick={close}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          
          <div className="text-gray-600 mb-4">
            A new version of the app is available. Click below to update and reload.
          </div>

          <div className="flex justify-end gap-2">
            <Button
              size="sm"
              variant="primary"
              onClick={() => updateServiceWorker(true)}
              className="w-full flex items-center justify-center gap-2"
            >
              <RefreshCw className="w-4 h-4" />
              Update and Reload
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
